if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"public-site","remotes":[{"alias":"polaris","name":"polaris","entry":"https://www.buoyhealth.com/polaris/federated/remote.js","shareScope":"default"}]},
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}